const WOW = window.wow;

window.initGameIcons = (gamesImages, gameIconClass) => {
    const gamesIcons = $(`.${gameIconClass}`);
    const md = new MobileDetect(window.navigator.userAgent);

    // const onGameIconClick = (e) => {
    //     const currentTarget = $(e.currentTarget);
    //     const target = $(e.target);

    //     // check that block buttons not clicked
    //     if (!!target.closest('.game__play').length) {
    //         return;
    //     }

    //     window.location.href = currentTarget.data('url');
    // }

    const playGameBtn = $('.game-page-preload');
    playGameBtn.click((e) => {
        e.preventDefault();
        const target = $(e.currentTarget);
        const gameUrl = target.data('url');

        window.location.href = gameUrl;
    });

    // for (const id in gamesImages) {
    //     var image_main = new Image();
    //     image_main.onload = () => {
    //         const iconBlock = $(`.${gameIconClass}-${id}`);

    //         if (md.mobile()) {
    //             iconBlock.addClass(`games-smooth-icons-${id}`);
    //         } else {
    //             var image_alt = new Image();
    //             image_alt.onload = () => {
    //                 iconBlock.addClass(`games-smooth-icons-${id}`);
    //             };
    //             image_alt.src = gamesImages[id]['image_alt'];
    //         }
    //     };
    //     image_main.src = gamesImages[id]['image_main'];
    // }

    const activateIcon = (iconElement) => {
        const video = iconElement.find('video').get(0);

        iconElement.addClass('is_active');
        video && video.play();
    }
    const deactivateIcon = (iconElement) => {
        const video = iconElement.find('video').get(0);

        iconElement.removeClass('is_active');
        if (video) {
            video.pause();
            video.currentTime = 0;
        }
    }

    // set hover if not mobile
    if (!md.mobile()) {
        gamesIcons.hover(
            (e) => {
                const target = $(e.currentTarget);
                if (target.hasClass('is_icon_only') || $(window).width() >= 1024) {
                    activateIcon(target);
                }
            },
            (e) => {
                const target = $(e.currentTarget);
                if (target.hasClass('is_icon_only') || $(window).width() >= 1024) {
                    deactivateIcon(target);
                }
            }
        );
    } else {
        gamesIcons.click((e) => {
            const target = $(e.currentTarget);
            if (!target.hasClass('is_icon_only')) {
                return;
            }

            if (target.hasClass('is_active')) {
                deactivateIcon(target);
            } else {
                activateIcon(target);
            }
        })
    }

    // set tilt
    if (!md.mobile() && $(window).width() >= 1024) {
        $(`.${gameIconClass}`).tilt({
            maxTilt: 15,
            perspective: 1000,
            speed: 600,
            transition: true,
        });
    }
};

const getGamesPageData = (key) => {
    let data = sessionStorage.getItem(`games-page-${key}-data`);
    if (!!data) {
        return JSON.parse(data);
    }
    return {
        queryNum: 1,
        responseData: [],
    };
};

const setGamesPageData = (key, data) => {
    sessionStorage.setItem(`games-page-${key}-data`, JSON.stringify(data));
};

window.initGamesPageTag = (options = {
    code,
    maxPages,
    // buttons: {
    //     play,
    //     info
    // },
    showMoreUrl,
    limitPerPage,
    view
    // locale
}) => {
    const code = options.code;
    const maxPages = options.maxPages;
    const limitPerPage = options.limitPerPage || 12;
    const view = options.view || 'default';
    // const gameButtonImage = options.buttons.play;
    // const infoButtonImage = options.buttons.info;
    const showMoreUrl = options.showMoreUrl;
    // const storageKey = `${code}-${options.locale}`

    const showMoreButton = $(`#show-more-games-${code}`);
    const gamesBlock = $(`#sorting-tag-${code}`);

    let queryNum = 1;

    // let gamesPageData = getGamesPageData(storageKey);
    // let queryNum = gamesPageData.queryNum;
    // let loadedGames = gamesPageData.responseData;

    const disableLoadButton = () => {
        showMoreButton.prop('disabled', true);
    };
    const enableLoadButton = () => {
        showMoreButton.prop('disabled', false);
    };
    const hideLoadButton = () => {
        showMoreButton.hide();
        disableLoadButton();
    };

    const successHandler = (data) => {
        if (!data || !data.length) {
            hideLoadButton();
            return;
        }
        const gamesIconsClass = `games-tabs-${code}-${queryNum}`;

        gamesBlock.append(data);
        // window.initGameIcons(gamesImages, gamesIconsClass);
        // gamesPageData.responseData[queryNum] = data;

        const wow = new WOW.WOW({
            boxClass: gamesIconsClass
        });
        wow.init();
    }

    showMoreButton.click(() => {
        disableLoadButton();

        const completeHandler = () => {
            queryNum++;
            if (queryNum < maxPages) {
                enableLoadButton();
            } else {
                hideLoadButton();
            }

            // gamesPageData.queryNum = queryNum;
            // setGamesPageData(storageKey, gamesPageData);
        };

        $.ajax({
            method: "GET",
            url: `${showMoreUrl}?offsetPage=${queryNum}&tagCode=${code}&pageLimit=${limitPerPage}&viewTemplate=${view}`,
            dataType: "text",
            success: successHandler,
            complete: completeHandler,
        });
    });

    // for (const loadedQueryId in loadedGames) {
    //     let data = loadedGames[loadedQueryId];

    //     if (!!data) {
    //         successHandler(data);
    //     }
    // }

    if (queryNum >= maxPages) {
        hideLoadButton();
    }
};
